<ng-container *ngIf="atosDuplicados && atosDuplicados.length > 0">

    <div style="padding-top: 15px; padding-bottom: 15px;">
        <div class="table-responsive" style="border: 1px solid #00205b;">
            <table suiteRfbTable tableClass="table table-striped tabela tabela-modal">
                <caption>ATOS COM A MESMA EPÍGRAFE</caption>
                <thead>
                    <tr>
                        <th class="text-center">
                            <span>ID</span>
                            <suite-rfb-sort-by [asc]="sortedBy[0]"
                                (onSort)="sortByColuna(0, $event)"></suite-rfb-sort-by>
                        </th>
                        <th class="text-center">
                            <span>Tipo</span>
                            <suite-rfb-sort-by [asc]="sortedBy[1]"
                                (onSort)="sortByColuna(1, $event)"></suite-rfb-sort-by>
                        </th>
                        <th class="text-center">
                            <span>Número</span>
                            <suite-rfb-sort-by [asc]="sortedBy[2]"
                                (onSort)="sortByColuna(2, $event)"></suite-rfb-sort-by>
                        </th>
                        <th class="text-center">
                            <span>Órgao/unidade</span>
                            <suite-rfb-sort-by [asc]="sortedBy[3]"
                                (onSort)="sortByColuna(3, $event)"></suite-rfb-sort-by>
                        </th>
                        <th class="text-center">
                            <span>Data do ato</span>
                            <suite-rfb-sort-by [asc]="sortedBy[4]"
                                (onSort)="sortByColuna(4, $event)"></suite-rfb-sort-by>
                        </th>
                        <th class="text-center">
                            <span>Data da publicação</span>
                            <suite-rfb-sort-by [asc]="sortedBy[5]"
                                (onSort)="sortByColuna(5, $event)"></suite-rfb-sort-by>
                        </th>
                        <th class="text-center">
                            <span>Ementa</span>
                        </th>
                        <th class="text-center" colspan="1">
                            Ações
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ato of atosDuplicados" [style]="ato.republicacao?{'background-color': '#fccfd1'}:{}">
                        <td class="text-center">
                            {{ ato.idAto }}
                        </td>
                        <td class="text-center">
                            {{ ato.siglaTipoAto }}
                        </td>
                        <td class="text-center">
                            {{ ato.numeroAto }}
                        </td>
                        <td class="text-center">
                            {{ ato.orgaosStr }}
                        </td>
                        <td class="text-center">
                            {{ ato.dataAtoStr }}
                        </td>
                        <td class="text-center">
                            {{ ato.dataPublicacaoStr }}
                        </td>
                        <td class="text-center">
                            <span title="{{ ato.ementa }}">
                                {{ getEmenta(ato.ementa) }}
                            </span>
                        </td>
                        <td class="text-center">
                            <a [routerLink]="['/atos/visualizar-ato', ato.idAto]" target="_blank">
                                <span title="Visualizar ato" container="body">
                                    <span class="material-icons icon-24">visibility</span>
                                </span>
                            </a>
                            <span>&nbsp;</span>
                            <a (click)="compararAtos(ato.idAto)" target="_blank" *ngIf="conteudoAto && conteudoAto.length > 0">
                                <span title="Comparar atos" container="body">
                                    <span class="material-icons icon-24">compare_arrows</span>
                                </span>
                            </a>
                            <span title="Preencha o Conteúdo do ato para comparar" container="body" *ngIf="!conteudoAto || conteudoAto.length === 0">
                                <span class="material-icons icon-24" style="color: lightgray; cursor: default;">compare_arrows</span>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <app-comparar-atos *ngIf="exibirModalCompararAtos"
        [conteudoAto]="conteudoAto"
        [idAtoBase]="idAtoBase"
        [idAtoCorrecao]="idAtoCorrecao"
        (fechar)="fecharModalCompararAtos()"
        (fecharEProsseguir)="fecharModalEProsseguir()"
        (fecharERepublicar)="fecharModalCompararAtosERepublicar($event)"
        (fecharEConverterPublicacaoRepetida)="fecharModalCompararAtosEConverterPublicacaoRepetida($event)">
    </app-comparar-atos>

</ng-container>